import type { ReactNode } from 'react';

import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { Image } from '@realadvisor/image';

import { cssTokens } from '@shared/theme/StyleProvider';

// var()-backed fills must go through `style` (CSS) — var() does not resolve in
// SVG presentation attributes like `fill=`, so the color scheme is honored here
export const CoverPhotoPlaceholder = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1472 300"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid slice"
  >
    <g clipPath="url(#clip0_2840_4094)">
      <path d="M0 0H1472V300H0V0Z" style={{ fill: cssTokens.coverBg }} />
      <circle
        cx="174.5"
        cy="80.5"
        r="324.5"
        style={{ fill: cssTokens.coverCircle1 }}
      />
      <circle
        cx="1383.5"
        cy="301.5"
        r="324.5"
        style={{ fill: cssTokens.coverCircle2 }}
      />
    </g>
    <defs>
      <clipPath id="clip0_2840_4094">
        <rect width="1472" height="300" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

type CoverPhotoProps = {
  src?: string | null;
  width: number;
  sx: SxProps<Theme>;
  children?: ReactNode;
};

export const CoverPhoto = ({ src, width, sx, children }: CoverPhotoProps) => (
  <Box sx={sx}>
    {src ? (
      <Image
        src={src}
        options={{ w: width }}
        css={{ width: '100%', height: '100%', objectFit: 'cover' }}
      />
    ) : (
      <CoverPhotoPlaceholder />
    )}
    {children}
  </Box>
);
